import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../../messages";
import toastr from "toastr";
import FactorQuestionServices from "./FactorQuestion.services";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const getFactorQuestion = (filters,setData, setCount,setLoader,setError, setFormError) => async (dispatch) => {
  try {
    setLoader(true)
    const resp = await FactorQuestionServices.getFactorQuestion(filters);
    setData(resp.data.data)
    setCount(resp.data.count)
    setError("")
    setFormError("")
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    }else{
      message = messages.applicationError
    }
    setError(message)
    setFormError("")
  } finally {
    setLoader(false)
  }
};

export const getFactorQuestionById = (id) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_FACTOR_QUESTION_BY_ID,
      payload: true,
    });
    const resp = await FactorQuestionServices.getFactorQuestionById(id);
    dispatch({
      type: actions.GET_FACTOR_QUESTION_BY_ID,
      payload: resp.data,
    });
    dispatch({
      type: actions.FACTOR_QUESTION_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FACTOR_QUESTION_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_FACTOR_QUESTION_BY_ID,
      payload: false,
    });
  }
};

export const saveFactorQuestion = (req, data, setData, count, setCount, setSaveLoader, setError, setFormError) => async (dispatch, getState) => {
  try {
    setSaveLoader(true)
    const resp = await FactorQuestionServices.saveFactorQuestion(req);
    const _data = data;
    _data.push(resp.data)
    setData(_data)
    setCount(count+1)
    setError("")
    setFormError("")
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    setError("")
    setFormError(message)
  } finally {
    setSaveLoader(false)
  }
};

export const editFactorQuestion = (req, id, index, data, setData, count, setCount, setSaveLoader, setError, setFormError) => async (dispatch, getState) => {
  try {
    setSaveLoader(true)
    const resp = await FactorQuestionServices.editFactorQuestion(id, req);
    let _data = data;
    _data[index]=resp.data
    setData(_data)
    setError("")
    setFormError("")
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    setError("")
    setFormError(message)
  } finally {
    setSaveLoader(false)
  }
};

export const deleteFactorQuestion = (id, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_FACTOR_QUESTION,
      payload: true,
    });
    await FactorQuestionServices.deleteFactorQuestion(id);
    const { factorTemplates, factorTemplatesLength } = getState().factorTemplate;
    factorTemplates.splice(index, 1);
    dispatch({
      type: actions.GET_FACTOR_QUESTION,
      payload: {
        factorTemplates: factorTemplates,
        factorTemplatesLength: factorTemplatesLength - 1,
      },
    });
    dispatch({
      type: actions.FACTOR_QUESTION_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FACTOR_QUESTION_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_FACTOR_QUESTION,
      payload: false,
    });
  }
};